import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PrimeArtifact } from '../../types/primeArtifact';
import { PrimeModelCreationData } from '../../types/primeModel';

interface PrimeModelState {
  artifacts: PrimeArtifact[];
  loading: boolean;
  error: string | null;
  selectedArtifact: PrimeArtifact | null;
  modelData: PrimeModelCreationData | null;
  showSummary: boolean;
}

const initialState: PrimeModelState = {
  artifacts: [],
  loading: false,
  error: null,
  selectedArtifact: null,
  modelData: null,
  showSummary: false,
};

const primeModelSlice = createSlice({
  name: 'primeModel',
  initialState,
  reducers: {
    setArtifacts: (state, action: PayloadAction<PrimeArtifact[]>) => {
      state.artifacts = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setSelectedArtifact: (state, action: PayloadAction<PrimeArtifact | null>) => {
      state.selectedArtifact = action.payload;
    },
    setModelData: (state, action: PayloadAction<PrimeModelCreationData | null>) => {
      state.modelData = action.payload;
    },
    setShowSummary: (state, action: PayloadAction<boolean>) => {
      state.showSummary = action.payload;
    },
    resetModel: (state) => {
      state.selectedArtifact = null;
      state.modelData = null;
      state.showSummary = false;
    },
  },
});

export const {
  setArtifacts,
  setLoading,
  setError,
  setSelectedArtifact,
  setModelData,
  setShowSummary,
  resetModel,
} = primeModelSlice.actions;

export default primeModelSlice.reducer;
